import { Component, OnInit, Input } from '@angular/core';
import { PaymentStatus } from '../payment-entry';
import { PaymentEntryStatusService } from './payment-entry-status.service';
import { PaymentStatusUI } from './payment-entry-status';

@Component({
  selector: 'app-payment-entry-status',
  templateUrl: './payment-entry-status.component.html',
  styleUrls: ['./payment-entry-status.component.less'],
  standalone: false
})
export class PaymentEntryStatusComponent implements OnInit {
  @Input() status: PaymentStatus;
  @Input() isBadgeView = true;
  @Input() waitForFunds: boolean;
  paymentStatusUI: PaymentStatusUI;

  constructor(private paymentEntryStatusService: PaymentEntryStatusService) {}

  statusClass: string;
  statusLabelCode: string;

  ngOnInit(): void {
    this.paymentStatusUI = this.paymentEntryStatusService.getPaymentStatusUI(this.status, this.waitForFunds);
    this.statusClass = this.paymentStatusUI?.toString();
    this.statusLabelCode = 'payment.status.' + this.paymentStatusUI?.toString();
  }
}
